import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../i18n/LanguageContext';
import './Goal.css';

const goalCodes = [
    { code: 'exam', icon: '🎓' },
    { code: 'travel', icon: '✈️' },
    { code: 'work', icon: '💼' },
    { code: 'family', icon: '👨‍👩‍👧' },
    { code: 'culture', icon: '🎭' },
    { code: 'brain', icon: '🧠' },
];

function Goal() {
    const navigate = useNavigate();
    const { t } = useLanguage();
    const [selected, setSelected] = useState([]);

    const toggleGoal = (code) => {
        if (selected.includes(code)) {
            setSelected(selected.filter(c => c !== code));
        } else {
            if (selected.length < 3) {
                setSelected([...selected, code]);
            }
        }
    };

    const handleConfirm = () => {
        if (selected.length > 0) {
            localStorage.setItem('vozoly_goals', JSON.stringify(selected));
            localStorage.setItem('vozoly_onboarding_step', 'path');
            navigate('/onboarding/path');
        }
    };

    return (
        <div className="goal-screen">

            <div className="goal-top">
                <button className="goal-back" onClick={() => navigate('/onboarding/target-language')}>←</button>
                <div className="goal-step">{t('onboarding.goal.step')}</div>
            </div>

            <div className="goal-content">
                <div className="goal-heading">{t('onboarding.goal.heading')}</div>
                <div className="goal-subheading">
                    {t('onboarding.goal.subheading')}
                </div>

                <div className="goal-counter">
                    {selected.length === 0 && <span className="goal-counter-empty">{t('onboarding.goal.selectAtLeastOne')}</span>}
                    {selected.length > 0 && (
                        <span className="goal-counter-filled">
                            {selected.length} {t('onboarding.goal.selected')} 3
                            {selected.length === 3 && ` ${t('onboarding.goal.maxReached')}`}
                        </span>
                    )}
                </div>

                <div className="goal-list">
                    {goalCodes.map(goal => {
                        const isSelected = selected.includes(goal.code);
                        const isDisabled = !isSelected && selected.length >= 3;
                        return (
                            <div
                                key={goal.code}
                                className={`goal-card ${isSelected ? 'selected' : ''} ${isDisabled ? 'disabled' : ''}`}
                                onClick={() => !isDisabled && toggleGoal(goal.code)}
                            >
                                <div className={`goal-card-icon ${isSelected ? 'selected' : ''}`}>{goal.icon}</div>
                                <div className="goal-card-info">
                                    <div className="goal-card-title">{t(`onboarding.goal.goals.${goal.code}.title`)}</div>
                                    <div className="goal-card-desc">{t(`onboarding.goal.goals.${goal.code}.description`)}</div>
                                </div>
                                <div className={`goal-checkbox ${isSelected ? 'checked' : ''}`}>
                                    {isSelected && <span className="goal-checkbox-tick">✓</span>}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>

            <div className="goal-footer">
                <button
                    className="goal-confirm-btn"
                    disabled={selected.length === 0}
                    onClick={handleConfirm}
                >
                    {selected.length === 0 ? t('onboarding.goal.chooseGoal') : `${t('onboarding.goal.continue')} →`}
                </button>
            </div>

        </div>
    );
}

export default Goal;